import { MdPointOfSale } from 'react-icons/md';

import { AdminTitle } from '../../components';
import { SimuladorTaxas } from './components/SimuladorTaxas';
import { SimuladorContainer } from './styles';

export const Simulador = () => (
  <SimuladorContainer>
    <AdminTitle title="Simulador de Taxas" icon={<MdPointOfSale />} />
    <SimuladorTaxas />
  </SimuladorContainer>
);
